import React,{useState,useEffect} from "react";
import API from "../../../utils/API";
import {FormGroup, Input, Label} from "reactstrap";
import LenderSelect from "../../formfields/LenderSelect";

const Exclusivity = ({title,type,elementId,onClose}) => {

    const [data,setData] = useState([])
    const [options,setOptions] = useState([])

    useEffect(() => {
        API.post('/admin/filter',{elementId:elementId,type:type,filterTitle:title}).then((response) => {

            setData(response.data.data.data.list)
            if (response.data.data.options) {
                setOptions(response.data.data.options)
            }
        });
    }, [title,type])

    const onChange = (name, value) => {
        setData(value);
    }

    const saveFilter = () => {
        API.put('/admin/filter',{elementId:elementId,type:type,filterTitle:title,data:{list:data}}).then((response) => {
            onClose()
        });
    }

    return (
        <>
            <div className="row">
                <div className="col pt-2">
                    <h5>Filter by: {title}</h5>
                </div>
                <div className="col-auto text-right">
                    <button onClick={onClose} className="btn btn-outline-secondary mb-2">X</button><br/>
                </div>
            </div>
            <div className="mt-3">
                {options.length > 0 &&
                    <LenderSelect onChange={onChange} value={data} isSingle={false} name={'lender'}/>
                }
            </div>
            <div className="mt-3 text-center">
                <button className="btn btn-primary" onClick={saveFilter}>Save</button>
            </div>
        </>
    )
}

export default Exclusivity;
